/**
 * Identifier-shaped patterns that must never reach a redacted (public)
 * surface — a GUID (tenant / client / subscription id), an image digest, a
 * registry host, or the subscription/resource-group segment of an ARM
 * resource id.
 *
 * Mirrors scripts/ci-issue-body.mjs's `BANNED_BODY_PATTERNS` — same idea,
 * duplicated here rather than imported because the CLI (apps/cli) does not
 * reach across into the repo-root scripts/ directory. Keep the two lists in
 * sync by hand if either changes.
 */
export const IDENTIFIER_PATTERNS: readonly RegExp[] = [
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, // any GUID (tenant/client/subscription id)
  /\bsha256:[0-9a-f]{8,}/gi, // image digests
  /\.azurecr\.io/gi, // registry hosts
  /\bsubscriptions\/[^\s'"]+/gi, // ARM ids (subscription path)
  /\bresourceGroups\/[^\s'"]+/gi,
];

/** Replace every match of every identifier-shaped pattern with a fixed placeholder. */
export function scrubIdentifiers(text: string): string {
  let out = text;
  for (const pattern of IDENTIFIER_PATTERNS) out = out.replace(pattern, "[redacted]");
  return out;
}
